import React, { useEffect, useRef } from "react";

const FOCALISABLES = 'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

const PanneauEffacement = ({ titreId, onFermer, retourFocus, children }) => {
  const panneau = useRef(null);
  const rappels = useRef({ onFermer, retourFocus });
  rappels.current = { onFermer, retourFocus };

  useEffect(() => {
    document.getElementById(titreId)?.focus();
    const surTouche = (e) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      rappels.current.onFermer();
    };
    document.addEventListener("keydown", surTouche);
    return () => {
      document.removeEventListener("keydown", surTouche);
      rappels.current.retourFocus()?.focus();
    };
  }, [titreId]);

  // Le panneau est modal : la tabulation boucle sur ses commandes au lieu de repartir dans la page.
  const garderLeFocus = (e) => {
    if (e.key !== "Tab") return;
    const commandes = [...panneau.current.querySelectorAll(FOCALISABLES)];
    if (commandes.length === 0) return;
    const premiere = commandes[0];
    const derniere = commandes[commandes.length - 1];
    const surLeTitre = document.activeElement.id === titreId;
    if (e.shiftKey && (document.activeElement === premiere || surLeTitre)) {
      e.preventDefault();
      derniere.focus();
    } else if (!e.shiftKey && document.activeElement === derniere) {
      e.preventDefault();
      premiere.focus();
    }
  };

  return (
    <>
      <div className="effacement__voile" onClick={onFermer} aria-hidden="true" />
      <aside
        className="effacement__panneau"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titreId}
        ref={panneau}
        onKeyDown={garderLeFocus}
      >
        {children}
      </aside>
    </>
  );
};

export default PanneauEffacement;
